import config from 'utils/config';
const VALID_LOG_LEVELS = ['log', 'info', 'debug', 'error', 'warn'];

const log = ({level = 'error', message = '', metadata = {}}) => {
	if (!window.DD_LOGS) {
		return;
	}

	if (!VALID_LOG_LEVELS.includes(level)) {
		throw new Error(`Invalid level type for logger: ${level}`);
	}

	const userId = localStorage.getItem('id') || null;
	const domainId = localStorage.getItem('domainId') || null;
	const sessionToken = sessionStorage.getItem('session_token') || null;
	const messageToLog = message || metadata.message;
	const dataToLog = {
		level,
		message: messageToLog,
		appVersion: config.appVersion,
		userId,
		domainId,
		sessionToken,
		metadata,
	};

	window.DD_LOGS.logger[level](dataToLog);
};

export default log;
